import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { DatePicker, Typography } from "antd";
import styles from "./ExperienceBooking.module.css";

const { Text } = Typography

const DateSelector = ({ value, onChange, activeTab, error }) => {
    const [t] = useTranslation()
    const [open, setOpen] = useState(false);

    return (
        <div className={styles.guestsWrapper}>
            <div className={`${styles.inputContainer} ${open ? styles.activeBorder : ""} ${error ? styles.errorBorder : ""}`}>
                <span className={styles.inputLabel}>Date</span>
                <DatePicker
                    value={value}
                    disabled={activeTab === 2 || activeTab === 3}
                    onChange={onChange}
                    placeholder="Select Date"
                    format="MM/DD/YY"
                    suffixIcon={null}
                    className={styles.datePickerStyled}
                    allowClear={false}
                    bordered={false}
                    open={open}
                    onOpenChange={setOpen}
                    popupClassName={styles.dateDropdownPanel}
                />
            </div>
            {error && <Text style={{ color: "red" }}>{t("webIntegration.embedded_validation.date")}</Text>}
        </div>
    );
};

DateSelector.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    activeTab: PropTypes.number,
    error: PropTypes.bool
};

export default React.memo(DateSelector);
